import get from 'lodash-es/get';
import { Division } from '@reg/shared/model/division.model';
import { PercentPipe } from '@angular/common';

/**
 * Model to hold division discount data.
 */
export class DivisionDiscount {
    public static TYPE_PERCENT: string = 'percent';
    public static TYPE_AMOUNT: string = 'amount';

    public id: string = null;
    public eventId: string = null;
    public dollarDiscount: number = null;
    public percentageDiscount: number = null;
    public divisions: Division[] = [];

    public get type(): string {
        if (this.dollarDiscount > 0) {
            return DivisionDiscount.TYPE_AMOUNT;
        }

        return DivisionDiscount.TYPE_PERCENT;
    }

    public formatPercentage(): string {
        if (this.percentageDiscount) {
            return new PercentPipe('en-US').transform(this.percentageDiscount, '1.2-2');
        }

        return '';
    }

    public clone(): DivisionDiscount {
        const clone: DivisionDiscount = new DivisionDiscount();
        clone.id = this.id;
        clone.eventId = this.eventId;
        clone.dollarDiscount = this.dollarDiscount;
        clone.percentageDiscount = this.percentageDiscount;
        clone.divisions = this.divisions && this.divisions.map((d: Division) => d.clone());

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'divisionDiscount';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.relationships = {};
        json.data.attributes.dollarDiscount = 0;
        json.data.attributes.percentageDiscount = 0;

        if (this.dollarDiscount) {
            json.data.attributes.dollarDiscount = parseFloat(this.dollarDiscount.toString());
        } else if (this.percentageDiscount) {
            json.data.attributes.percentageDiscount = parseFloat(this.percentageDiscount.toString());
        }

        if (this.divisions !== null) {
            const jsonDivisions: any = {};
            jsonDivisions.data = [];

            for (const division of this.divisions) {
                jsonDivisions.data.push({ type: 'division', id: division.id });
            }

            json.data.relationships.divisions = jsonDivisions;
        }

        return JSON.stringify(json);
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: any, included: any[]): DivisionDiscount {
        const data: any = json.data || json;
        const attrs: any = data.attributes || {};

        this.id = data.id;
        this.eventId = attrs.eventId;
        this.dollarDiscount = attrs.dollarDiscount;
        this.percentageDiscount = attrs.percentageDiscount;

        const divisionList: any[] = get(data, 'relationships.divisions.data') || [];
        divisionList.forEach((x: any) => {
            const item: any = included.find((i: any) => i.id === x.id);

            if (item) {
                this.divisions.push((new Division()).deserialize(item, included));
            }
        });

        return this;
    }
}
